<template>
    <div class="content" v-loading.fullscreen.lock="loading">
      <base-header class="pb-6">
        <h2 slot="header" class="mb-0">Manage Global Alert</h2>
      </base-header>

      <div class="container-fluid mt--6">
        <card>
          <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <form @submit.prevent="handleSubmit(submit)">
              <div class="form-row flex-layout gap-30">
                <h2 slot="header" class="mb-0">Manage Global Alert</h2>
                <!-- Message -->
                <div class="col-md-12 flex-layout">
                  <label class="form-control-label">Message *</label>
                  <vue-editor
                    v-model="form.message"
                    :editorOptions="editorOptions"
                    class="rich-editor"
                  />
                </div>

                <!-- Color -->
                <div class="col-md-4 flex-layout">
                  <label class="form-control-label">Color *</label>
                  <el-select
                    v-model="form.color"
                    placeholder="Select color"
                    :rules="{ required: true }"
                  >
                    <el-option label="Red"  value="danger" />
                    <el-option label="Green" value="success" />
                    <el-option label="Yellow" value="warning" />
                  </el-select>
                </div>
                <div class="col-md-4 flex-layout">
                  <label class="form-control-label">Show On *</label>
                  <el-select
                    v-model="form.show_options"
                    placeholder="Select color"
                    :rules="{ required: true }"
                  >
                    <el-option label="Dashboard"  value="dashboard" />
                    <el-option label="Individual Sign Up" value="individual" />
                    <el-option label="Company Sign Up" value="company" />
                  </el-select>
                </div>

                <!-- Active Toggle -->
                <div class="col-md-4 flex-layout">
                  <label class="form-control-label">Active *</label>
                  <!-- v-model="form.isActive" -->
                  <el-switch
                  :value="form.isActive === 1"
                  @change="form.isActive = $event ? 1 : 0"
                  />
                </div>
                <!-- Active Toggle -->
                <div class="col-md-4 flex-layout">
                  <label class="form-control-label">Refresh *</label>
                  <!-- v-model="form.isActive" -->
                  <el-switch
                  :value="form.refresh === 1"
                  @change="form.refresh = $event ? 1 : 0"
                  />
                </div>
              </div>

              <div class="text-right">
                <base-button type="default" @click.prevent="$router.back()">
                  Cancel
                </base-button>
                <base-button type="primary" native-type="submit">
                  Save Alert
                </base-button>
              </div>
            </form>
          </validation-observer>
        </card>
      </div>
    </div>
  </template>

  <script>

  import { ValidationObserver } from 'vee-validate';
  import {VueEditor, Quill} from "vue2-editor";
  import {Switch, Select, Option} from "element-ui";
  export default {
    components: {
      ValidationObserver,
      [Select.name]: Select,
        [Option.name]: Option,
        [Switch.name]: Switch,
        VueEditor,
    },
    data() {
      return {
        loading: false,
        form: {
          show_options: 'dashboard',
          message: '',
          color: 'success',
          isActive: false,
          refresh: false,
        },
      };
    },
    mounted() {
      this.fetchAlert();
    },
    methods: {
      async fetchAlert() {
        this.loading = true;
        try {
          const { data } = await this.$http.get('alert/get');
          this.form = {
            message: data.message,
            color: data.color,
            isActive: data.isActive,
            refresh: data.refresh,
            show_options: data.show_options || 'dashboard',
          };
        } catch (err) {
          this.$toast.error('Failed to load alert');
        } finally {
          this.loading = false;
        }
      },
      async submit() {
        this.loading = true;
          const cleanedMessage = this.form.message.replace(/<(.|\n)*?>/g, '').trim();
        try {
          await this.$http.post('alert/update', this.form);
            this.$toast.success('Alert saved successfully',{
              timeout: 5000,
              toastClassName: "scorm-error-toast"
                    });
        } catch (err) {
          // Validation errors from backend
          const msg = err.response?.data?.message || 'Save failed';
          this.$toast.error(msg,{
              timeout: 5000,
              toastClassName: "scorm-error-toast"
                    });
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>

  <style scoped>
  .content {
    padding-top: 1rem;
  }
  .mb-3 {
    margin-bottom: 1rem;
  }

  .flex-layout {
    display:flex;
    flex-direction: column;
    gap:5px;
  }

  .gap-30 {
    gap:30px !important;
  }
  </style>
